// eslint-disable-next-line
import {
	UserLayout,
	BasicLayout,
	RouteView,
	BlankLayout,
	PageView,
} from '@/components/layouts'
import PassportLayout from '@/components/page/Passport/passport.component.vue'
import store from '@/store'
import partnerConfig from './partner.router.config'

function getLeafRoutePath(routers: any): any {
	for (const route of routers) {
		if (route.name.endsWith('List')) {
			return route.path
		}
		if (route.children && route.children.length) {
			return getLeafRoutePath(route.children)
		}
	}
	// TODO 调整为有权限的路由
	return '/Settings/UserCenter'
}

export const asyncRouterMap = [
	{
		path: '/',
		name: 'index',
		component: BasicLayout,
		meta: { title: '首页' },
		redirect: (to: any) => {
			return getLeafRoutePath(store.getters.addRouters)
		},
		children: [
			{
				path: '/AiiTasks',
				name: 'AiiTasks',
				component: RouteView,
				redirect: '/AiiTasks/TasksList',
				meta: {
					title: '人伤任务管理',
					icon: 'medicine-box',
					permission: ['taskList', 'addTask', 'exceptionList'],
				},
				children: [
					{
						path: '/AiiTasks/addTask',
						name: 'AiiAddTask',
						component: () =>
							import('@/views/AiiTasks/add-task-page/addTaskPage.vue'),
						meta: {
							title: '新建人伤任务',
							permission: ['addTask'],
						},
					},
					{
						path: '/AiiTasks/visitorArea',
						name: 'visitorArea',
						component: () =>
							import('@/views/AiiTasks/add-task-page/visitorArea.vue'),
						hidden: true,
						meta: {
							title: '作业覆盖区域',
						},
					},
					{
						path: '/AiiTasks/addTaskWithParam',
						name: 'AddTaskWithParam',
						component: () =>
							import('@/views/AiiTasks/add-task-page/addTaskPageWithParam.vue'),
						hidden: true,
						meta: {
							title: '新建人伤任务',
							permission: ['addTask'],
						},
					},
					{
						path: '/AiiTasks/TasksList',
						name: 'AiiTasksList',
						component: () => import('@/views/AiiTasks/TasksList.vue'),
						meta: {
							title: '人伤任务列表',
							permission: ['taskList'],
						},
					},
					{
						path: '/AiiTasks/exceptionList',
						name: 'exceptionList',
						component: () => import('@/views/AiiTasks/exceptionList.vue'),
						meta: {
							title: '异常案件列表',
							permission: ['exceptionList'],
						},
					},
					{
						path: '/AiiTasks/revisitList',
						name: 'revisitList',
						component: () => import('@/views/AiiTasks/revisit/revisitList.vue'),
						meta: {
							title: '未决跟踪列表',
							permission: ['revisitList'],
						},
					},
					{
						path: '/AiiTasks/wholeProcessList',
						name: 'wholeProcessList',
						component: () =>
							import('@/views/AiiTasks/wholeProcess/wholeProcessList.vue'),
						meta: {
							title: '整案订单列表',
							permission: ['wholeProcessList'],
						},
					},
					{
						path: '/AiiTasks/wholeProcessDetail/:id',
						name: 'WholeProcessDetail',
						component: () =>
							import('@/views/AiiTasks/wholeProcess/wholeProcessDetail.vue'),
						hidden: true,
						meta: {
							// 权限由操作的入口控制
							title: '整案订单详情',
						},
					},
					{
						path: '/AiiTasks/TasksDetail/:orderId/:taskType',
						name: 'commonTasksDetail',
						component: () =>
							import(
								'@/views/AiiTasks/common-task-detail/commonTasksDetail.vue'
							),
						hidden: true,
						meta: {
							title: '人伤任务详情',
						},
					},
					{
						// 与系统设置/编辑服务手册同路由
						path: '/Settings/EditManual',
						name: 'AiiTaskManual',
						hidden: true,
						component: () => import('@/views/AiiTasks/modifyManualPage.vue'),
						meta: {
							title: '编辑服务手册',
						},
					},
					{
						path: '/AiiTasks/addResurvey',
						name: 'AiiAddResurvey',
						component: () =>
							import('@/views/AiiTasks/add-task-page/addResurveyPage.vue'),
						hidden: true,
						meta: {
							title: '新建复勘任务',
							permission: ['addTask'],
						},
					},
				],
			},
			{
				path: '/investigate',
				name: 'investigate',
				component: RouteView,
				hidden: true,
				redirect: '/investigate/taskList',
				meta: {
					title: '调查任务管理',
					icon: 'search',
				},
				children: [
					{
						path: '/investigate/addTask',
						name: 'addInvestigateTask',
						component: () => import('@/views/investigate/addTaskPage.vue'),
						meta: {
							title: '新建调查任务',
							permission: ['investigateAdd'],
						},
					},
					{
						// 风险处理 -- 调查任务类型
						path: '/investigate/addRiskTask',
						name: 'addRiskTask',
						component: () => import('@/views/investigate/addRiskTaskPage.vue'),
						hidden: true,
						meta: {
							title: '新建调查任务',
						},
					},
					{
						path: '/investigate/taskList',
						name: 'investigateTaskList',
						component: () => import('@/views/investigate/taskList.vue'),
						meta: {
							title: '调查任务列表',
							permission: ['investigateList'],
						},
					},
					{
						path: '/investigate/taskDetail/:orderId',
						name: 'AiiTaskDetail',
						component: () => import('@/views/AiiTasks/TasksDetail.vue'),
						hidden: true,
						meta: {
							title: '调查任务详情',
						},
					},
				],
			},
			{
				path: '/mediate',
				name: 'mediate',
				component: RouteView,
				hidden: true,
				redirect: '/mediate/taskList',
				meta: {
					title: '调解任务管理',
					icon: {
						type: 'tiaojie',
					},
					// permission: ['conciliationList', 'addConciliation'],
				},
				children: [
					{
						path: '/mediate/addTask',
						name: 'addMediateTask',
						component: () => import('@/views/mediate/addTaskPage.vue'),
						meta: {
							title: '新建调解任务',
							permission: ['addConciliation'],
						},
					},
					{
						path: '/mediate/addOfflineMediate',
						name: 'addOfflineMediate',
						component: () => import('@/views/mediate/addOfflineMediate.vue'),
						hidden: true,
						meta: {
							title: '新建住院案件调解',
							// permission: ['addConciliation'],
						},
					},
					{
						path: '/mediate/taskList',
						name: 'mediateTaskList',
						component: () => import('@/views/mediate/taskList.vue'),
						meta: {
							title: '调解任务列表',
							permission: ['conciliationList'],
						},
					},
					{
						path: '/mediate/taskDetail/:orderId',
						name: 'mediateTaskDetail',
						component: () => import('@/views/mediate/taskDetail.vue'),
						hidden: true,
						meta: {
							title: '调解任务详情',
						},
					},
				],
			},
			{
				path: '/lawsuit',
				name: 'lawsuit',
				component: RouteView,
				redirect: '/lawsuit/taskList',
				meta: {
					title: '诉讼任务管理',
					icon: {
						type: 'susong',
					},
					permission: ['lawsuitList', 'addLawsuit'],
				},
				children: [
					{
						path: '/lawsuit/addTask',
						name: 'addLawsuitTask',
						component: () => import('@/views/lawsuit/addTaskPage.vue'),
						meta: {
							title: '新建诉讼任务',
							permission: ['addLawsuit'],
						},
					},
					{
						path: '/lawsuit/taskList',
						name: 'lawsuitTaskList',
						component: () => import('@/views/lawsuit/taskList.vue'),
						meta: {
							title: '诉讼任务列表',
							permission: ['lawsuitList'],
						},
					},
					{
						path: '/lawsuit/taskDetail/:orderId',
						name: 'lawsuitTaskDetail',
						component: () => import('@/views/lawsuit/taskDetail.vue'),
						hidden: true,
						meta: {
							title: '诉讼任务详情',
							permission: ['lawsuitDetail'],
						},
					},
					{
						path: '/lawsuit/setLitigationPlan/:orderId',
						name: 'setLitigationPlan',
						component: () => import('@/views/lawsuit/setLitigationPlan.vue'),
						hidden: true,
						meta: {
							title: '应诉方案',
						},
					},
				],
			},
			{
				path: '/riskTask',
				name: 'riskTask',
				component: RouteView,
				redirect: '/riskTask/taskList',
				meta: {
					title: '风险任务管理',
					icon: {
						type: 'fengxian',
					},
					permission: ['riskTaskList'],
				},
				children: [
					{
						path: '/riskTask/taskList',
						name: 'riskTaskList',
						component: () => import('@/views/riskTask/taskList.vue'),
						meta: {
							title: '风险任务列表',
							permission: ['riskTaskList'],
						},
					},
					{
						path: '/riskTask/taskDetail/:id',
						name: 'riskTaskDetail',
						component: () => import('@/views/riskTask/taskDetail.vue'),
						hidden: true,
						meta: {
							title: '风险任务详情',
						},
					},
				],
			},
			{
				path: '/bill',
				name: 'bill',
				component: RouteView,
				redirect: '/bill/taskList',
				meta: {
					title: '票据任务管理',
					icon: {
						type: 'fapiao',
					},
					permission: ['billList', 'billAdd'],
				},
				children: [
					{
						path: '/bill/addTask',
						name: 'addBillTask',
						component: () => import('@/views/bill/addTaskPage.vue'),
						meta: {
							title: '新建票据任务',
							permission: ['billAdd'],
						},
					},
					{
						path: '/bill/taskList',
						name: 'billTaskList',
						component: () => import('@/views/bill/taskList.vue'),
						meta: {
							title: '票据任务列表',
							permission: ['billList'],
						},
					},
					{
						path: '/bill/taskDetail/:orderId',
						name: 'billTaskDetail',
						component: () => import('@/views/bill/taskDetail.vue'),
						hidden: true,
						meta: {
							title: '票据任务详情',
						},
					},
				],
			},
			{
				path: '/bill2',
				name: 'bill2',
				component: RouteView,
				redirect: '/bill2/taskList',
				meta: {
					title: '票据任务管理',
					icon: {
						type: 'piaoju',
					},
					permission: ['bill2List', 'bill2Add'],
				},
				children: [
					{
						path: '/bill2/addTask',
						name: 'addBill2Task',
						component: () => import('@/views/bill2/addTaskPage.vue'),
						meta: {
							title: '新建票据任务',
							permission: ['bill2Add'],
						},
					},
					{
						path: '/bill2/taskList',
						name: 'bill2TaskList',
						component: () => import('@/views/bill2/taskList.vue'),
						meta: {
							title: '票据任务列表',
							permission: ['bill2List'],
						},
					},
					{
						path: '/bill2/taskDetail/:orderId/:taskType',
						name: 'bill2TaskDetail',
						component: () => import('@/views/bill2/taskDetail.vue'),
						hidden: true,
						meta: {
							title: '票据任务详情',
						},
					},
					{
						path: '/bill2/bosssoftTaskDetail/:orderId/:taskType',
						name: 'bosssoftTaskDetail',
						component: () => import('@/views/bill2/bosssoftTaskDetail.vue'),
						hidden: true,
						meta: {
							title: '票据任务详情',
						},
					},
					{
						path: '/bill2/taskEdit/:orderId/:taskType',
						name: 'bill2TaskEdit',
						component: () => import('@/views/bill2/taskEdit.vue'),
						hidden: true,
						meta: {
							title: '票据任务编辑',
						},
					},
				],
			},
			// {
			// 	path: '/verify',
			// 	name: 'verify',
			// 	component: RouteView,
			// 	redirect: '/verify/verifyList',
			// 	meta: {
			// 		title: '地址核验任务管理',
			// 		icon: 'security-scan',
			// 		permission: ['verifyList', 'addVerifyTask'],
			// 	},
			// 	children: [
			// 		{
			// 			path: '/verify/verifyList',
			// 			name: 'verifyList',
			// 			component: () => import('@/views/verify/verifyList.vue'),
			// 			meta: {
			// 				title: '核验列表',
			// 				permission: ['verifyList'],
			// 			},
			// 		},
			// 		{
			// 			path: '/verify/addVerifyTask',
			// 			name: 'addVerifyTask',
			// 			component: () => import('@/views/verify/addVerifyTask.vue'),
			// 			meta: {
			// 				title: '地址核验',
			// 				permission: ['addVerifyTask'],
			// 			},
			// 		},
			// 		{
			// 			path: '/verify/detail/:orderNo',
			// 			name: 'verifyDetail',
			// 			component: () => import('@/views/verify/verifyDetail.vue'),
			// 			hidden: true,
			// 			meta: {
			// 				title: '核验详情',
			// 			},
			// 		},
			// 	],
			// },
			partnerConfig,
			{
				path: '/returnVisit',
				component: RouteView,
				name: 'returnVisit',
				redirect: '/returnVisit/returnVisitList',
				meta: {
					title: '客服工作台',
					icon: {
						type: 'huifang',
					},
					permission: [
						'returnVisitList',
						'returnVisitQuestionnaire',
						'revisitQuestions',
						'workbenchCheckList',
					],
				},
				children: [
					{
						path: '/returnVisit/auditList',
						name: 'auditList',
						component: () => import('@/views/returnVisit/auditList.vue'),
						meta: {
							title: '初审列表',
							permission: ['workbenchCheckList'],
						},
					},
					{
						path: '/returnVisit/returnVisitList',
						name: 'returnVisitList',
						component: () => import('@/views/returnVisit/returnVisitList.vue'),
						meta: {
							title: '回访列表',
							permission: ['returnVisitList'],
						},
					},
					{
						path: '/returnVisit/returnVisitQuestionnaire',
						name: 'returnVisitQuestionnaire',
						component: () =>
							import('@/views/returnVisit/returnVisitQuestionnaire.vue'),
						meta: {
							title: '回访问卷管理',
							permission: ['returnVisitQuestionnaire'],
						},
					},
					{
						path: '/returnVisit/revisitQuestions',
						name: 'revisitQuestions',
						component: () => import('@/views/returnVisit/revisitQuestions.vue'),
						meta: {
							title: '题库管理',
							permission: ['revisitQuestions'],
						},
					},
					{
						path: '/returnVisit/addQuestionnaire',
						name: 'addReturnVisitQuestionnaire',
						component: () => import('@/views/returnVisit/addQuestionnaire.vue'),
						hidden: true,
						meta: {
							title: '新增问卷',
						},
					},
					{
						path: '/returnVisit/editQuestionnaire',
						name: 'editReturnVisitQuestionnaire',
						component: () =>
							import('@/views/returnVisit/editQuestionnaire.vue'),
						hidden: true,
						meta: {
							title: '编辑问卷',
						},
					},
					{
						path: '/returnVisit/tasksDetail/:id',
						name: 'returnVisitTaskDetail',
						component: () =>
							import('@/views/returnVisit/returnVisitDetail.vue'),
						hidden: true,
						meta: {
							title: '售后回访详情',
						},
					},
					{
						path: '/returnVisit/auditDetail/:orderId/:taskType',
						name: 'returnVisitAuditDetail',
						component: () =>
							import('@/views/returnVisit/auditDetail/index.vue'),
						hidden: true,
						meta: {
							title: '初审详情',
						},
					},
				],
			},
			{
				path: '/Settings',
				component: RouteView,
				name: 'Settings',
				redirect: '/Settings/UsersList',
				meta: {
					title: '系统设置',
					icon: 'setting',
					permission: [
						'companyUserList',
						'reconciliationList',
						'lawyerList',
						'lawyerDetail',
						'userCenter',
						'changePassword',
						'configurationList',
						'dispatchList',
						'editManual',
					],
				},
				children: [
					{
						path: '/Settings/Configuration',
						name: 'Configuration',
						component: () =>
							import(
								/* webpackChunkName: "Configuration" */ '@/views/Settings/Configuration.vue'
							),
						meta: {
							title: '配置管理',
							permission: ['configurationList'],
						},
					},
					{
						path: '/Settings/Holiday',
						name: 'Holiday',
						component: () => import('@/views/Settings/Holiday.vue'),
						hidden: true,
						meta: {
							title: '节假日设置',
							// permission: ['holidayConfig'],
						},
					},
					{
						path: '/Settings/Settlement',
						name: 'Settlement',
						component: () => import('@/views/Settings/Settlement.vue'),
						hidden: true,
						meta: {
							title: '结算参照物管理',
							// permission: ['settlementConfig'],
						},
					},
					{
						path: '/Settings/DispatchList',
						name: 'DispatchList',
						component: () =>
							import(
								/* webpackChunkName: "DispatchList" */ '@/views/Settings/DispatchList.vue'
							),
						meta: {
							title: '调度规则',
							permission: ['dispatchList'],
						},
					},
					{
						path: '/Settings/DispatchAdd',
						name: 'DispatchAdd',
						component: () =>
							import(
								/* webpackChunkName: "DispatchList" */ '@/views/Settings/DispatchRules/DispatchAdd.vue'
							),
						hidden: true,
						meta: {
							title: '新增调度规则',
						},
					},
					{
						path: '/Settings/DispatchUpdate',
						name: 'DispatchUpdate',
						component: () =>
							import(
								/* webpackChunkName: "DispatchList" */ '@/views/Settings/DispatchRules/DispatchUpdate.vue'
							),
						hidden: true,
						meta: {
							title: '修改调度规则',
						},
					},
					{
						path: '/Settings/EditManual',
						name: 'AiiTaskManual',
						component: () => import('@/views/AiiTasks/modifyManualPage.vue'),
						meta: {
							title: '编辑服务手册',
							permission: ['editManual'],
						},
					},
					{
						path: '/Settings/Rules',
						component: RouteView,
						name: 'Rules',
						redirect: '/Settings/Rules/RulesList',
						meta: {
							title: '规则配置',
							permission: ['WPConfigList'],
						},
						children: [
							{
								path: '/Settings/Rules/RulesList',
								name: 'WPRulesList',
								component: () =>
									import(
										/* webpackChunkName: "Rules" */ '@/views/Settings/Rules/RulesList.vue'
									),
								meta: {
									title: '规则配置',
									permission: ['WPConfigList'],
								},
							},
							{
								path: '/Settings/Rules/addRule',
								name: 'addWPRule',
								component: () =>
									import(
										/* webpackChunkName: "Rules" */ '@/views/Settings/Rules/addRule.vue'
									),
								hidden: true,
								meta: {
									title: '人伤规则配置',
									// 由列表的按钮权限控制
								},
							},
							{
								path: '/Settings/Rules/editRule',
								name: 'editWPRule',
								component: () =>
									import(
										/* webpackChunkName: "Rules" */ '@/views/Settings/Rules/editRule.vue'
									),
								hidden: true,
								meta: {
									title: '人伤规则配置',
									// 由列表操作列的按钮权限控制
								},
							},
						],
					},
					{
						path: '/Settings/UsersList/Company',
						name: 'UserList',
						component: () =>
							import(
								/* webpackChunkName: "Company" */ '@/views/Settings/UsersList.vue'
							),
						meta: {
							title: '账号管理',
							permission: ['companyUserList'],
						},
					},
					{
						path: '/Settings/reconciliationList',
						name: 'ReconciliationList',
						component: () =>
							import(
								/* webpackChunkName: "Company" */ '@/views/Settings/reconciliationList.vue'
							),
						meta: {
							title: '对账管理',
							permission: ['reconciliationList'],
						},
					},
					{
						path: '/setting/lawyerList',
						name: 'lawyerList',
						component: () =>
							import(
								/* webpackChunkName: "Company" */ '@/views/Settings/lawyer/lawyerList.vue'
							),
						meta: {
							title: '律师管理',
							permission: ['lawyerList'],
						},
					},
					{
						path: '/setting/lawyerDetail/:id',
						name: 'lawyerDetail',
						component: () =>
							import(
								/* webpackChunkName: "Company" */ '@/views/Settings/lawyer/lawyerDetail.vue'
							),
						hidden: true,
						meta: {
							title: '律师详情',
							permission: ['lawyerDetail'],
						},
					},
					{
						path: '/Settings/UserCenter',
						name: 'UserCenter',
						component: () =>
							import(
								/* webpackChunkName: "UserCenter" */ '@/views/Settings/UserCenter.vue'
							),
						meta: {
							title: '个人中心',
							permission: ['userCenter'],
						},
					},
					{
						path: '/Settings/Password',
						name: 'ChangePassword',
						component: () =>
							import(
								/* webpackChunkName: "Password" */ '@/views/Settings/Password.vue'
							),
						meta: {
							title: '修改密码',
							permission: ['changePassword'],
						},
					},
				],
			},
			// 与回访管理路由区分开 回访管理菜单与权限存在强耦合
			// 存在回访详情权限时不一定有回访管理菜单
			{
				path: '/returnVisit',
				component: RouteView,
				name: 'reVisitDetail',
				hidden: true,
				meta: {
					title: '回访详情',
				},
				children: [
					{
						// 未决回访详情（仅查看）
						path: '/returnVisit/pendingDetail/:id',
						name: 'returnVisitPendingDetail',
						component: () => import('@/views/returnVisit/pendingDetail.vue'),
						hidden: true,
						meta: {
							title: '未决回访详情',
						},
					},
					{
						// 未决回访详情（可编辑）
						path: '/returnVisit/collectPendingInfo',
						name: 'returnVisitCollectPendingInfo',
						component: () =>
							import('@/views/returnVisit/collectPendingInfo.vue'),
						hidden: true,
						meta: {
							title: '未决回访详情',
						},
					},
				],
			},
			{
				// TODO 共用任务详情与人伤任务详情共用路由组件引起路由组件不更新问题
				path: '/CommonAiiTask',
				component: RouteView,
				name: 'CommonAiiTask',
				redirect: '/CommonAiiTask/TasksDetail/:orderId/:taskType',
				meta: {
					title: '任务详情',
				},
				hidden: true,
				children: [
					{
						path: '/CommonAiiTask/TasksDetail/:orderId/:taskType',
						name: 'CommonAiiTaskDetail',
						component: () =>
							import(
								'@/views/AiiTasks/common-task-detail/CommonAiiTaskDetail.vue'
							),
						meta: {
							title: '任务详情',
							// permission: ['commonAiiTaskDetail'],
						},
					},
				],
			},
		],
	},
	{
		path: '/manual/manualPreview',
		component: () => import('@/views/AiiTasks/modifyManual.vue'),
		name: 'manualPreview',
		meta: {
			title: '用户手册',
		},
		hidden: true,
	},
	{
		path: '/liaison/liaisonPreview',
		component: () => import('@/views/AiiTasks/liaisonPreview.vue'),
		name: 'liaisonPreview',
		meta: {
			title: '理赔服务联络卡',
		},
		hidden: true,
	},
	{
		path: '/HelpCenter',
		component: () => import('@/views/HelpCenter/index.vue'),
		name: 'HelpCenter',
		meta: {
			title: '帮助中心',
		},
		hidden: true,
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true,
	},
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
	{
		path: '/passport',
		component: PassportLayout,
		redirect: '/passport/login',
		hidden: true,
		children: [
			{
				path: 'login',
				name: 'login',
				component: () =>
					import(
						/* webpackChunkName: "user" */ '@/views/Passport/Login/Index.vue'
					),
				meta: {
					title: '登录',
					auth: false,
				},
			},
		],
	},
	{
		path: '/ddJump',
		name: 'ddJump',
		component: () => import('@/views/Passport/Login/ddJump.vue'),
		meta: {
			title: '',
			auth: false,
		},
		hidden: true,
	},
	{
		path: '/forgotPwd',
		component: PassportLayout,
		redirect: '/forgotPwd/index',
		hidden: true,
		children: [
			{
				path: 'index',
				name: 'forgotPwd',
				component: () =>
					import(
						/* webpackChunkName: "user" */ '@/views/Passport/forgotPwd.vue'
					),
				meta: {
					title: '忘记密码',
					auth: false,
				},
			},
		],
	},
	{
		path: '/snapshot/:orderId/:token',
		component: () => import('@/views/screenshots/index.vue'),
		name: 'snapshot',
		meta: {
			title: '凭据',
			auth: false,
		},
		hidden: true,
	},
	{
		path: '/manual/preview/:orderId/:token',
		component: () => import('@/views/AiiTasks/modifyManual.vue'),
		name: 'manualPreview',
		meta: {
			title: '用户手册',
			auth: false,
		},
		hidden: true,
	},
	{
		path: '/liaison/preview/:orderId/:token',
		component: () => import('@/views/AiiTasks/liaisonPreview.vue'),
		name: 'liaisonPreviewScreenshot',
		meta: {
			title: '理赔服务联络卡',
			auth: false,
		},
		hidden: true,
	},
	{
		path: '/link-task-detail/:orderId/:taskType/:desensitize/:key/:watermark',
		name: 'LinkTaskDetail',
		component: () =>
			import('@/views/AiiTasks/common-task-detail/LinkTaskDetail.vue'),
		meta: {
			title: '任务详情',
		},
		hidden: true,
	},
	{
		path: '/link-add-task',
		name: 'LinkAddTask',
		component: () => import('@/views/AiiTasks/add-task-page/LinkAddTask.vue'),
		meta: {
			title: '新建人伤任务',
		},
		hidden: true,
	},
	//内嵌第三方服管平台
	{
		path: '/tasksDetail/:orderId/:taskType',
		name: 'AiiTasksDetail',
		component: () =>
			import('@/views/AiiTasks/common-task-detail/LinkTaskDetail.vue'),
		hidden: true,
		meta: {
			title: '人伤任务详情',
		},
	},
	{
		path: '/partnerOrderDetail/:canChecked/:orderId/:dispatchId',
		name: 'AiiPartnerOrderDetail',
		component: () => import('@/views/partner/order/PartnerOrderDetail.vue'),
		hidden: true,
		meta: {
			title: '订单作业详情',
		},
	},
	{
		path: '/error-page',
		name: 'ErrorPage',
		component: () => import('@/views/ErrorPage.vue'),
		meta: {
			title: '错误页面',
			auth: false,
		},
		hidden: true,
	},
	{
		path: '/404',
		component: () =>
			import(/* webpackChunkName: "fail" */ '@/views/exception/404.vue'),
	},
]
